import { render, staticRenderFns } from "./WriteDetails.vue?vue&type=template&id=f993ce10&scoped=true&"
import script from "./WriteDetails.vue?vue&type=script&lang=js&"
export * from "./WriteDetails.vue?vue&type=script&lang=js&"
import style0 from "./WriteDetails.vue?vue&type=style&index=0&id=f993ce10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f993ce10",
  null
  
)

export default component.exports